import React from 'react';
import {
  Avatar, Backdrop,
  Box,
  Card, CardContent,
  CircularProgress,
  Divider, Input, List, ListItem, ListItemAvatar,
  ListItemText, Paper,
  Typography
} from '@material-ui/core';
import PageviewIcon from '@material-ui/icons/Pageview';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import { useEffect, useMemo, useState } from 'react';
import axios from 'src/utils/axios';
import { sc } from 'src/utils/Common';
import { text } from '../../modules/languages/index';

const useStyles = makeStyles((theme) => ({
  card: { borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.05)' },
  searchBar: {
    padding: '4px 12px', display: 'flex', alignItems: 'center',
    marginBottom: theme.spacing(2), borderRadius: 8,
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
    '&:hover': { borderColor: theme.palette.primary.main }
  },
  scrollContainer: {
    maxHeight: '500px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: '5px' },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: '10px'
    }
  },
  // FİYAT BURADA GÜNCELLENDİ
  priceTag: {
    fontWeight: 800,               // Daha kalın (Bold) yapıldı
    marginLeft: 'auto',            // Sağa yaslayan kritik komut
    paddingLeft: theme.spacing(2), // Metinle fiyat arasına boşluk
    whiteSpace: 'nowrap',          // Fiyatın alt satıra kaymasını engeller
    fontSize: '1rem',
    textAlign: 'right'             // Metin içi sağa hizalama
  }
}));

function SatisFiyat() {
  const classes = useStyles();
  const [todos, setTodos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    axios.get('/GetArtemisSatisAksesuarFiyat').then(res => {
      setTodos(res.data || []);
      setLoading(false);
    });
  }, []);

  const filtered = useMemo(() =>
    todos.filter(i => sc(i.MALZEME_STOK_NO, searchTerm) || sc(i.ACIKLAMA, searchTerm)),
    [todos, searchTerm]);


  const handleShowMaterial = (code) => {
    const newWindow = window.open("", "_blank");
    axios.post('/FileImportExport/ArtemisMalzeme',
      { MALZEME_STOK_NO: code },
      { responseType: 'blob', headers: { 'Content-Type': 'application/json' } }
    ).then(res => {
      newWindow.location.href = URL.createObjectURL(res.data);
    }).catch(() => newWindow.close());
  };


  return (
    <Card className={classes.card}>
      <Box p={2}>
        <Paper className={classes.searchBar} elevation={0}>
          <SearchIcon color="action" />
          <Input
            fullWidth disableUnderline
            placeholder={text("Arama_Yap")}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Paper>
      </Box>
      <Divider />
      <CardContent style={{ padding: 0 }}>
        <div className={classes.scrollContainer}>
          <List>
            {filtered.map((item) => (
              <ListItem key={item.MALZEME_STOK_NO} divider>
                <ListItemAvatar onClick={() => handleShowMaterial(item.MALZEME_STOK_NO)}>
                  <Avatar style={{ backgroundColor: '#FF9800' }}><PageviewIcon /></Avatar>
                </ListItemAvatar>
                <ListItemText primary={item.MALZEME_STOK_NO} secondary={item.ACIKLAMA} />
                {/* Sağa yaslanmış ve Bold fiyat etiketi */}
                <Typography className={classes.priceTag}>
                  {item.KDVLI_FIYAT} ₺
                </Typography>
              </ListItem>
            ))}
          </List>
        </div>
      </CardContent>
      <Backdrop open={loading} style={{ zIndex: 10, color: '#fff', position: 'absolute' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Card>
  );
}

export default SatisFiyat;